import { render, staticRenderFns } from "./LmPeopleTypesNewOrEdit.vue?vue&type=template&id=04443245&"
import script from "./LmPeopleTypesNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LmPeopleTypesNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./LmPeopleTypesNewOrEdit.vue?vue&type=style&index=0&id=04443245&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports